//console.log('process.env:', process.env);

const redirectUri = process.env.REACT_APP_REDIRECT_URI;
const backendUrl = process.env.REACT_APP_BACK_END_URL; 
const clientId = process.env.REACT_APP_CLIENT_ID;

/* console.log('redirectUri:', redirectUri);
console.log('backendUrl:', backendUrl);  
console.log('clientId:', clientId); */

const authority = 'https://login.microsoftonline.com/560ec2b0-df0c-4e8c-9848-a15718863bb6';

const successorURL = backendUrl + '/api/successors';
const directReportsURL = backendUrl + '/api/Reports';
const workerURL = backendUrl + '/api/Worker';
const employeesURL = backendUrl + '/api/Employees';
const HierarchyURL = backendUrl + '/Hierarchy';

export { redirectUri, clientId, authority, directReportsURL, workerURL, employeesURL,  HierarchyURL,successorURL };
